import { useEffect, useState } from "react";
import { useSelector ,useDispatch } from "react-redux";
import { MdDelete } from "react-icons/md";
import { Button } from "antd";
import { FaPlus } from "react-icons/fa";
import { AiFillSetting } from "react-icons/ai";

import ReduxActions from "../../redux/actions";
import TableListParams from "./TableListParams";
import TableControl from "../../component/table/TableControl";
import styled from "styled-components";

const TableExtend = styled(TableControl)`
  margin-top: 0px;
  width: 100%;
`

const ButtonAddParams = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #05BC9B;
  color : white;
  width: fit-content;
  font-size : 16px;
  height: 40px;
`

export default function TableMgtParams(props) {

  const selectedParams = useSelector(state => state.compareGraph.selectedParams)
  const [data, setData] = useState([])
  const dispatch = useDispatch();
  
  useEffect(() => {
  }, [dispatch]);

  const column = [
    { title: "สถานี", dataIndex: "stations_name", align: "left", sorter: (a, b) => a.stations_name - b.stations_name, },
    { title: "เซนเซอร์", dataIndex: "sensor_name", align: "left", sorter: (a, b) => a.sensor_name - b.sensor_name, },
    { title: "พารามิเตอร์", dataIndex: "parameter_name", align: "left", sorter: (a, b) => a.parameter_name - b.parameter_name, },
    { title: <AiFillSetting/>, dataIndex: "delete", align: "center", width: 40, className:"cell-delete", 
    render: (_, record) => (
      <>
        <Button
          onClick={ props.onEdit ? props.onEdit : ()=>{
            dispatch(ReduxActions.compareGraph.deleteSelectedParams({id: record.id}))
          }}>
            <MdDelete style={{color: "red"}}/>
        </Button>
      </>
    ),
    },
  ];

  const tableTopRightBtn = (
    <ButtonAddParams className='btn-add-data' icon={<FaPlus className='icon-add-data' />} onClick={()=>{dispatch(ReduxActions.popup.toggleVisible(true, '', '', <TableListParams />))}}>
      เพิ่มพารามิเตอร์
    </ButtonAddParams>
  )

  return (
    <TableExtend
      className={
        "table-mgt-params" +
        (props.className ? props.className : "")
      }
      topRightButton={tableTopRightBtn}
      columns={column}
      data={selectedParams}
      disabledSearch
      disabledPagination
    />
  );
}
